import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.assign.js";
import { getCookie } from './cookies';
import { getPPU } from './utils';

var getDefaultParam = function getDefaultParam() {
  var cookieid = getCookie('idzz') || getCookie('id58') || getPPU().UID || getCookie('uid') || getCookie('uuid');
  var timestamp = new Date().getTime();
  var appid = 'ZHUANZHUAN';
  var ua = encodeURIComponent(navigator.userAgent);
  var version = getCookie('v') || null;
  var clienttime = timestamp;
  return {
    cookieid: cookieid,
    timestamp: timestamp,
    appid: appid,
    ua: ua,
    version: version,
    clienttime: clienttime
  };
};

var generateUrl = function generateUrl(pre, param) {
  var url = "".concat(pre, "?");

  for (var p in param) {
    if (param.hasOwnProperty(p)) {
      url += "".concat(p, "=").concat(param[p], "&");
    }
  }

  url = url.slice(0, -1);
  return url;
};

export var lego = function lego(pagetype, actiontype, addtionalParams) {
  var params = getDefaultParam();
  params.pagetype = pagetype || 'ZHUANZHUANM';
  params.actiontype = actiontype || "".concat(params.pagetype, "-PV");
  var token = getCookie('tk') || getCookie('idzz') || getCookie('id58') || '';
  var uid = getCookie('uid') || '';
  var t = getCookie('t') || getCookie('zz_t') || '';
  params.backup = Object.assign(addtionalParams, {
    token: token,
    uid: uid,
    t: t
  });
  params.backup = encodeURIComponent(JSON.stringify(params.backup));
  var lego = 'https://lego.zhuanzhuan.com/page/mark';
  var img = new Image();
  img.src = generateUrl(lego, params);

  img.onerror = img.onload = function () {
    img = null;
  };
};